import { getUsername } from "@/_services/userConfiguration"
import { localStorageKeys } from "@/_services/utils"

// These helpers only touch localStorage and intentionally do NOT import "firebase/*".
// They live in their own light module so that eager code paths (logout, user config cleanup)
// can call them without dragging the heavy Firebase SDK into the initial bundle.
// The actual Firebase messaging logic stays in firebase-messaging.js, which is loaded
// on demand via dynamic import().

export function resetFirebaseToken() {
  const username = getUsername()
  if (username) localStorage.removeItem(`${localStorageKeys.FIREBASE_TOKEN_PREFIX}${username}`)
}

export function cleanLocalStorage() {
  Object.keys(localStorage).forEach(key => key.startsWith(localStorageKeys.FIREBASE_TOKEN_PREFIX) && localStorage.removeItem(key))
}
